/**
 * 新闻资讯管理后台api
 * 新闻资讯管理后台相关接口
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The NewsCreateForm model module.
   * @module news/model/NewsCreateForm
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>NewsCreateForm</code>.
   * @alias module:news/model/NewsCreateForm
   * @class
   * @param title {String} 新闻标题
   * @param categoryId {Integer} 新闻分类：1-通知，2-动态，3-政策
   * @param content {String} 新闻内容（富文本格式）
   */
  var exports = function(title, categoryId, content) {
    var _this = this;

    _this['title'] = title;
    _this['categoryId'] = categoryId;
    _this['content'] = content;


  };

  /**
   * Constructs a <code>NewsCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:news/model/NewsCreateForm} obj Optional instance to populate.
   * @return {module:news/model/NewsCreateForm} The populated <code>NewsCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'categoryId')) {
        obj['categoryId'] = ApiClient.convertToType(data['categoryId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'content')) {
        obj['content'] = ApiClient.convertToType(data['content'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'coverUri')) {
        obj['coverUri'] = ApiClient.convertToType(data['coverUri'], 'String');
      }
    }
    return obj;
  }

  /**
   * 新闻标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 新闻分类：1-通知，2-动态，3-政策
   * @member {Integer} categoryId
   */
  exports.prototype['categoryId'] = undefined;
  /**
   * 新闻内容（富文本格式）
   * @member {String} content
   */
  exports.prototype['content'] = undefined;
  /**
   * 新闻摘要，不传则自动从内容截取
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 封面图片URL（使用现有OSS上传接口）
   * @member {String} coverUri
   */
  exports.prototype['coverUri'] = undefined;



  export default exports;
;


